<template>
  <div class="property-dialog">
    <v-start
            v-if="type === 'start'"
            :nodeData="nodeData"
            :setData="setData"
            :key="nodeData.id"
            :lf="lf"
    />
    <jugement
            v-if="type === 'jugement'"
            :nodeData="nodeData"
            :key="nodeData.id"
            :lf="lf" />
    <subFlow
            v-if="type === 'subflow'"
            :nodeData="nodeData"
            :subData="subData"
            :key="nodeData.id"
            :lf="lf" />
    <wareHouse
            v-if="type === 'warehouse' || type === 'circlenew' || type==='subprocess' "
            :nodeData="nodeData"
            :subData="subData"
            :key="nodeData.id"
            :lf="lf" />
    <approval
            v-if="type === 'approval'"
            :nodeData="nodeData"
            :setData="setData"
            :key="nodeData.id"
            :lf="lf" />
    <task
            v-if="type === 'task'"
            :nodeData="nodeData"
            :setData="setData"
            :key="nodeData.id"
            :lf="lf" />
    <wait
            v-if="type === 'wait'"
            :nodeData="nodeData"
            :setData="setData"
            :key="nodeData.id"
            :lf="lf" />
    <end
            v-if="type === 'end'"
            :nodeData="nodeData"
            :setData="setData"
            :key="nodeData.id"
            :lf="lf" />
    <c-line
            v-if="type === 'polyline'"
            :nodeData="nodeData"
            :key="nodeData.id"
            :lf="lf"/>
    <User
      v-if="type === 'user'"
      :nodeData="nodeData"
      :key="nodeData.id"
      :lf="lf"/>
    <c-rect
            v-if="type === 'rect'"
            :nodeData="nodeData"
            :key="nodeData.id"
            :lf="lf"/>

  </div>
</template>
<script>
import User from './User.vue'
import vStart from './Start.vue'
import cLine from './LineYN.vue'
import cRect from './Rect.vue'
import subFlow from './SubFlow.vue'
import approval from './Approval.vue'
import task from './Task.vue'
import wait from './Wait.vue'
import end from './End.vue'

import Jugement from "./Jugement"
import wareHouse from "./Warehouse"

export default {
  name: 'PropertyDialog',
  components: {
    User,
    cLine,
    cRect,
    Jugement,
    vStart,
    subFlow,
    wareHouse,
    approval,
    task,
    wait,
    end,
  },
  props: {
    nodeData: Object,
    subData: Object,
    setData: Object,
    lf: Object
  },
  watch: {
    nodeData: {
      handler(n, o) {
        this.nodeid=n.id;
        this.type=n.type
      },
      // deep:true,
    },
  },
  data () {
    return {
      nodeid:"",
      type:""
    }
  },

}
</script>
<style>
.property-dialog{
  padding: 20px;
}
</style>
